import { useChartContext } from '@dbt-labs/sourdough';

export const ModelExecutionGridlines = () => {
  const chartContext = useChartContext();
  if (!chartContext || !chartContext.chartMeta) {
    return null;
  }

  const meta = chartContext.chartMeta;

  const tickScale = meta.yScale;
  const widthScale = meta.xScale;

  if (
    (widthScale.kind !== 'category' && widthScale.kind !== 'time') ||
    tickScale.kind !== 'linear'
  ) {
    return null;
  }

  let [x1, x2] = [0, 0];
  if (widthScale.kind === 'category') {
    x1 = widthScale.scale.range()[0] + (meta.margin?.left || 0);
    x2 = widthScale.scale.range()[1] + (meta.margin?.left || 0);
  } else if (widthScale.kind === 'time') {
    x1 = widthScale.scale(widthScale.scale.domain()[0]);
    x2 = widthScale.scale(widthScale.scale.domain()[1]);
  }

  return (
    <>
      {tickScale.scale.ticks(10).map((tick: any, i) => {
        if (i === 0) {
          return null;
        }
        return (
          <line
            key={tick}
            x1={x1}
            x2={x2}
            y1={tickScale.scale(tick)}
            y2={tickScale.scale(tick)}
            strokeDasharray="10, 2"
            className="stroke-borderMuted"
          />
        );
      })}
      {/* <line
        x1={x1}
        x2={x2}
        y1={0}
        y2={0}
        // strokeDasharray="8, 3"
        className="stroke-borderMuted"
      /> */}
    </>
  );
};
